// translates a league status to its stage counterpart
export const ProgramStatusToStageKey = {
    pending: 'upcoming',
    registration_open: 'upcoming',
    needs_approval: 'upcoming',
    ready: 'upcoming',
    active: 'active',
    completed: 'archived',
    cancelled: 'archived',
    error: 'archived',
    staged: 'staged',
    draft: 'staged', // not in original but seems about right
};
export const ProgramStatusEnum = Object.freeze({
    active: 'active',
    cancelled: 'cancelled',
    completed: 'completed',
    draft: 'draft',
    error: 'error',
    needs_approval: 'needs_approval',
    pending: 'pending',
    ready: 'ready',
    registration_open: 'registration_open',
    staged: 'staged',
});
export var PlanningSheetLeagueStatusEnum;
(function (PlanningSheetLeagueStatusEnum) {
    PlanningSheetLeagueStatusEnum["DISCOVERABLE"] = "Discoverable";
    PlanningSheetLeagueStatusEnum["UNDISCOVERABLE"] = "Undiscoverable";
    PlanningSheetLeagueStatusEnum["SOLD_OUT"] = "Sold Out";
    PlanningSheetLeagueStatusEnum["CUT"] = "Cut";
})(PlanningSheetLeagueStatusEnum || (PlanningSheetLeagueStatusEnum = {}));
